$( "a[href*=\\#]:not([href=\\#])" ).bind( 'touchstart click',
  function( e) {
    e.preventDefault();
    if ( location.pathname.replace( /^\//, "" ) == this.pathname.replace( /^\//, "" ) && location.hostname == this.hostname ) {
      var target = $( this.hash );
      target = target.length ? target : $( "[name=" + this.hash.slice( 1 ) + "]" );
      if ( target.length ) {
        $( "html,body" ).animate( {
          scrollTop: target.offset().top
        }, 1000 );
        return true;
      }
    }
  }
);



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/anchor_effect.js
 ** module id = 146
 ** module chunks = 0
 **/